import { styled, Typography } from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
  width: '100%',
  background: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  overflow: 'hidden',
  marginTop: '16px',
  marginBottom: '16px',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  background: theme.palette.grey[100],
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    background: theme.palette.grey[200],
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

export const Content = styled('div')(() => ({
  padding: '16px',
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(1, 1fr)',
}));
